import React from 'react'
import { Link } from 'react-router-dom'
import FormSF from '../../../../widgets/form/FormSF'
import CardUI from '../../../../widgets/layout/CardUI'
import BadgeUI from '../../../../widgets/output/BadgeUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import FileUploadModalSF from '../../../../widgets/form/FileUploadModalSF'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import ButtonTinyUI from '../../../../widgets/action/ButtonTinyUI'
import SpinnerUI from '../../../../widgets/output/SpinnerUI'
import { getOptionLabel } from 'react-select-v2/lib/builtins'
import ResolutionDateModalSF from './ResolutionDateModalSF'
import BoardMeetingDateModalSF from './BoardMeetingDateModalSF'
import LinkWithSpinnerUI from '../../../../widgets/action/LinkWithSpinnerUI'
import ButtonTinyWithSpinnerUI from '../../../../widgets/action/ButtonTinyWithSpinnerUI'
import ErrorMessage2UI from '../../../../widgets/form/ErrorMessage2UI'
import ErrorMessageUI from '../../../../widgets/form/ErrorMessageUI'

const DocumentSignUI = ({ context, loan, onRefreshClick,
  loanDocsSubmitted, onRecreateLoanDocsSubmit, loanDocsSuccessMsg, loanDocsErrorList,
  //
  onLDPDFUploadClick, ldPDFUploadSubmitted, ldPDFUploadSuccessMsg,
  ldPDFUploadErrorList, ldPDFUploadMode, onLDPDFUploadCancel, onLDPDFUpload,
  //
  onRegenerateSanctionLetterSubmit, sanctionLetterSubmitted, sanctionLetterSuccessMsg, sanctionLetterErrorList,
  onRegenerateLoanDocsSubmit, regenerateLoanDocSubmitted, regenerateLoanDocSuccessMsg, regenerateLoanDocErrorList,
  selectedDocId, docSubmitted, documentList, onDownloadDocClick, fileErrorList, downloadRequested,
  onResolutionDateClick, resolutionDateChangeMode, onCancelResolutionDateClick, onUploadResolutionClick,
  onUploadResolutionCancelClick, resolutionUploadMode, onResolutionUpload, resolutionErrorList,
  //
  onGeneratePGhtml2pdf, generatePGhtml2pdfErrorList,
}) =>
  <div>
    {
      !loan.resolutionSign && loan.agreementSignList.length === 0 &&
      <span>No documents yet</span>
    }

    {/*
      loan.sanction && loan.sanction.status &&
      <SanctionUI context={context} loan={loan} documentList={documentList}
        onRegenerateSanctionLetterSubmit={onRegenerateSanctionLetterSubmit}
        sanctionLetterSubmitted={sanctionLetterSubmitted}
        sanctionLetterSuccessMsg={sanctionLetterSuccessMsg}
        sanctionLetterErrorList={sanctionLetterErrorList}
        onDownloadDocClick={onDownloadDocClick}
      />
    */}

    {
      loan.resolutionSign &&
      <ResolutionsUI context={context} loan={loan} documentList={documentList}
        onResolutionDateClick={onResolutionDateClick}
        onDownloadDocClick={onDownloadDocClick}
        onUploadResolutionClick={onUploadResolutionClick}
        onUploadResolutionCancelClick={onUploadResolutionCancelClick}
        resolutionUploadMode={resolutionUploadMode}
        onResolutionUpload={onResolutionUpload}
        resolutionErrorList={resolutionErrorList}
      />
    }

    <ResolutionDateModalSF context={context} loan={loan} updateMode={resolutionDateChangeMode && (loan.appFlavor == 'classic' && loan.loanFlavor != 'small_loan')}
      onCancelClick={onCancelResolutionDateClick} onRefreshClick={onRefreshClick}
      onDownloadDocClick={onDownloadDocClick}
    />

    <BoardMeetingDateModalSF context={context} loan={loan} updateMode={resolutionDateChangeMode && (loan.appFlavor == 'small_loan' || loan.loanFlavor == 'small_loan')}
      onCancelClick={onCancelResolutionDateClick} onRefreshClick={onRefreshClick}
      onDownloadDocClick={onDownloadDocClick}
    />

    <LoanDocumentUI context={context} loan={loan} documentList={documentList}
      onRecreateLoanDocsSubmit={onRecreateLoanDocsSubmit} loanDocsSubmitted={loanDocsSubmitted}
      loanDocsSuccessMsg={loanDocsSuccessMsg} loanDocsErrorList={loanDocsErrorList}
      docSubmitted={docSubmitted} selectedDocId={selectedDocId}
      onRegenerateLoanDocsSubmit={onRegenerateLoanDocsSubmit}
      regenerateLoanDocSuccessMsg={regenerateLoanDocSuccessMsg}
      regenerateLoanDocErrorList={regenerateLoanDocErrorList}
      onDownloadDocClick={onDownloadDocClick}
      onLDPDFUploadClick={onLDPDFUploadClick}
      ldPDFUploadSubmitted={ldPDFUploadSubmitted}
      ldPDFUploadSuccessMsg={ldPDFUploadSuccessMsg}
      ldPDFUploadErrorList={ldPDFUploadErrorList}
      ldPDFUploadMode={ldPDFUploadMode}
      onLDPDFUploadCancel={onLDPDFUploadCancel}
      onLDPDFUpload={onLDPDFUpload}
      onGeneratePGhtml2pdf={onGeneratePGhtml2pdf}
      generatePGhtml2pdfErrorList={generatePGhtml2pdfErrorList}
    />
  </div>

const SanctionUI = ({ context, loan, documentList,
  onRegenerateSanctionLetterSubmit, sanctionLetterSubmitted,
  sanctionLetterSuccessMsg, sanctionLetterErrorList,
  onDownloadDocClick
}) =>
  <CardUI title='Sanction Letter' className='g_m_top_100'>
    <div className='g_flex_h g_flex_top'>
      <span className='g_flex_v'>
        <DateUI label='Offered' date={loan.sanction.dateF1} notLabel='Not offered' />
        <DateUI label='Lender approved' date={loan.sanction.reviewDateF1} notLabel='Lender has not approved' />
        <DateUI label='Borrower signed' date={loan.sanction.signDateF1} notLabel='Borrower has not signed' />
        <DownloadUI documentList={documentList} onDownloadDocClick={onDownloadDocClick}
          documentCode='sanction_letter' documentName='SanctionLetter.pdf'
        />
      </span>
      <div className='g_flex_v g_text_right'>
        <span className='g_m_bottom_25'><BadgeUI label={loan.sanction.status} /> </span>
      </div>
    </div>
    {
      loan.sanction && loan.sanction.status && loan.status === 'sanctioned' &&
      <div className='g_flex_h g_flex_right'>
        <FormSF context={context} buttonLabel='Regenerate Sanction Letter'
          onSubmit={onRegenerateSanctionLetterSubmit} busy={sanctionLetterSubmitted}
          successMsg={sanctionLetterSuccessMsg} errorList={sanctionLetterErrorList}
          inlineButton={true}
        />
      </div>
    }
  </CardUI>

const ResolutionsUI = ({ context, loan, documentList,
  onResolutionDateClick,
  onDownloadDocClick, onUploadResolutionClick, onUploadResolutionCancelClick,
  resolutionUploadMode, onResolutionUpload, resolutionErrorList
}) =>
  <CardUI title='Resolutions' className='g_m_top_100'>
    <div className='g_flex_h g_flex_top'>
      <span className='g_flex_v'>
        {/* <span>
          Board meeting {loan.resolutionSign.boardMeetingDateF1 || 'NA'}
          , shareholder meeting {loan.resolutionSign.shareholderMeetingDateF1 || 'NA'}
          {
            context.permissions.includes('su_manage') && loan.resolutionSign.status !== 'completed' &&
            <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onResolutionDateClick} />
          }
        </span> */}
        <DateUI label='Borrower signed' date={loan.resolutionSign.signDateF1} notLabel='Borrower has not signed' />
        <DateUI label='Lender approved' date={loan.resolutionSign.reviewDateF1} notLabel='Lender has not approved' />
        <DownloadUI documentList={documentList} onDownloadDocClick={onDownloadDocClick}
          documentCode='resolutions' documentName='Resolutions.pdf'
        />
        {
          loan.resolutionSign.templateName &&
          <span className='g_m_top_50'>Template: {loan.resolutionSign.templateName}</span>
        }
        {
          loan.resolutionSign.version &&
          <span>{loan.resolutionSign.version}</span>
        }
        <div className='g_flex_v g_m_top_100'>
          {loan.resolutionSign && loan.resolutionSign.templateName && (
            <div className='g_flex_v g_m_bottom_100'>
              <b>Custom Resolutions</b>
              <ButtonTinyWithSpinnerUI label={'Re-publish Loan Resolutions with PDF Upload'}
                onClick={onUploadResolutionClick} className='g_m_top_50'
                alignLeft={true} errorList={resolutionErrorList}
              />
            </div>
          )}
        </div>

      </span>
      <div className='g_flex_v g_flex_right'>
        <span className='g_m_bottom_25 g_text_right'><BadgeUI label={loan.resolutionSign.status} /></span>
      </div>
      <FileUploadModalSF
        context={context}
        uploadMode={resolutionUploadMode}
        onCancelClick={onUploadResolutionCancelClick}
        signedUrlApi={`/api/su/loans/${loan.loanId}/documents/resolution/pdfDocument/fileUploadSignedUrl`}
        onUpload={onResolutionUpload}
      />

    </div>
  </CardUI>

const LoanDocumentUI = ({ context, loan, documentList,
  docSubmitted, selectedDocId, onRegenerateLoanDocsSubmit,
  regenerateLoanDocSuccessMsg, regenerateLoanDocErrorList,
  onRecreateLoanDocsSubmit, loanDocsSubmitted,
  loanDocsSuccessMsg, loanDocsErrorList,
  onDownloadDocClick,
  onLDPDFUploadClick, ldPDFUploadSubmitted, ldPDFUploadSuccessMsg, ldPDFUploadErrorList,
  ldPDFUploadMode, onLDPDFUploadCancel, onLDPDFUpload,
  onGeneratePGhtml2pdf, generatePGhtml2pdfErrorList,
}) =>
  <div className='g_m_top_1001'>
    {
      loan.agreementSignList.map((aggr, i) =>
        <CardUI key={i} className='g_m_top_100' title={aggr.name}>
          <div className='g_flex_h g_flex_top'>
            <span>
              {
                aggr.directorSignList && aggr.directorSignList.map((dir, j) =>
                  <div key={j}>
                    {dir.fullName}, {(aggr.code === 'co_borrower_ndu' && dir.userId === 'co_borrower') ? 'co borrower' : 'borrower'}
                    {
                      dir.signDateF1 &&
                      <span className='g_muted'>, signed {dir.signDateF1}</span>
                    }
                  </div>
                )
              }
              {
                aggr.lenderSignee &&
                <div>{aggr.lenderSignee}, lender
                  {
                    aggr.lenderSignDateF1 &&
                    <span className='g_muted'>, signed {aggr.lenderSignDateF1}</span>
                  }
                </div>
              }
              {
                aggr.escrowSignee &&
                <div>{aggr.escrowSignee}, escrow
                  {
                    aggr.escrowSignDateF1 &&
                    <span className='g_muted'>, signed {aggr.escrowSignDateF1}</span>
                  }
                </div>
              }
            </span>
            <div className='g_flex_v g_text_right'>
              <span className='g_text_right'><BadgeUI label={aggr.status} /></span>
            </div>
          </div>

          <div className='g_flex_v g_m_top_100'>
            {
              aggr.status !== 'completed' && aggr.code !== 'addendum' && loan.resolutionSign.boardMeetingDateF1 &&
              <div className='g_flex_v'>
                <div className='g_flex_v g_m_bottom_100'>
                  <b>Standard {aggr.name}</b>
                  <ButtonTinyWithSpinnerUI label={'Re-publish Standard ' + aggr.name}
                    onClick={onRegenerateLoanDocsSubmit} className='g_m_top_25'
                    rowId={aggr.code}
                    alignLeft={true} busy={docSubmitted && selectedDocId === aggr.code}
                    successMsg={!docSubmitted && selectedDocId === aggr.code && regenerateLoanDocSuccessMsg}
                    errorList={!docSubmitted && selectedDocId === aggr.code && regenerateLoanDocErrorList}
                  />
                </div>

                <div>
                  <b>Custom {aggr.name}</b>
                  <ButtonTinyWithSpinnerUI label={'Re-publish ' + aggr.name + ' with PDF Upload'}
                    rowId={aggr.code} className='g_m_top_25'
                    onClick={onLDPDFUploadClick}
                    alignLeft={true} busy={ldPDFUploadSubmitted && selectedDocId === aggr.code}
                    successMsg={!ldPDFUploadSubmitted && selectedDocId === aggr.code &&ldPDFUploadSuccessMsg} errorList={!ldPDFUploadSubmitted && selectedDocId === aggr.code && ldPDFUploadErrorList}
                  />
                </div>
              </div>
            }
            {
              aggr.status !== 'completed' && aggr.code === 'addendum' &&
              <div>
                <b>Custom {aggr.name}</b>
                <ButtonTinyWithSpinnerUI label={'Re-publish ' + aggr.name + ' with PDF Upload'}
                  rowId={aggr.code} className='g_m_top_25'
                  onClick={onLDPDFUploadClick}
                  alignLeft={true} busy={ldPDFUploadSubmitted}
                  successMsg={ldPDFUploadSuccessMsg} errorList={ldPDFUploadErrorList}
                />
              </div>
            }
            {
              documentList &&
              documentList.map(({ documentId, fileName }) => ((
                documentId === aggr.code &&
                <div key={documentId} className='g_flex_v g_m_top_100'>
                  <b>Published {aggr.name}</b>
                  <Link className='g_m_top_25' onClick={onDownloadDocClick} to='#' data-type={aggr.code}>
                    Download {fileName} offered for signing
                  </Link>
                </div>
              )))
            }
          </div>
        </CardUI>
      )
    }

    <FileUploadModalSF
      context={context}
      uploadMode={ldPDFUploadMode}
      onCancelClick={onLDPDFUploadCancel}
      signedUrlApi={`/api/su/loans/${loan.loanId}/pdfDocuments/${selectedDocId}/fileUploadSignedUrl`}
      onUpload={onLDPDFUpload}
    />

    {/* {
      loan.resolutionSign && context.permissions.includes('su_superuser') &&
      <div className='g_flex_h g_m_top_100'>
        <span className='g_muted'>
          Regenerate all loan documents in this section (superuser)
        </span>
        <FormSF context={context} buttonLabel='Regenerate Loan Documents'
          onSubmit={onRecreateLoanDocsSubmit} busy={loanDocsSubmitted}
          successMsg={loanDocsSuccessMsg} errorList={loanDocsErrorList}
          inlineButton={true}
        />
      </div>
    } */}
  </div>

const DateUI = ({ label, date, notLabel }) =>
  <span>
    {
      date &&
      <>{label} {date}</>
    }
    {
      !date &&
      <>{notLabel}</>
    }
  </span>

const DownloadUI = ({ documentList, onDownloadDocClick, documentCode, documentName }) =>
  <span>
    {
      documentList &&
      documentList.filter(d => d.documentId === documentCode).map(({ documentId, fileName }) =>
        <Link key={documentId} className='g_m_top_25' onClick={onDownloadDocClick} to='#' data-type={documentCode}>
          Download {documentName} offered for signing
        </Link>
      )
    }
  </span>

export default DocumentSignUI

